// =============================================
// useLoginForm — shared login form state + submit handler
// Kipikid - מערכת נוכחות ילדים בגנים
// =============================================

import { useState, useCallback } from 'react';

export function useLoginForm(onSubmit: (username: string, password: string) => Promise<void>) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = useCallback(async (e?: React.FormEvent) => {
    e?.preventDefault();
    if (!username || !password) {
      setError('יש להזין שם משתמש וסיסמה');
      return;
    }
    setError('');
    setIsLoading(true);
    try {
      await onSubmit(username, password);
    } catch (err: unknown) {
      const message = err instanceof Error ? err.message : 'שגיאה בהתחברות';
      setError(message || 'שגיאה בהתחברות');
    } finally {
      setIsLoading(false);
    }
  }, [username, password, onSubmit]);

  return {
    username, setUsername,
    password, setPassword,
    showPassword, setShowPassword,
    error, setError,
    isLoading,
    handleSubmit,
  };
}
